export const checkValidPassword = (password) => {
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    // had to disable lint here to check for all characters, tried some approaches but lint is still throwing error
    // eslint-disable-next-line no-useless-escape
    const hasSpecialChar = /[!@#$%^&*()_+{}\[\]:;"'<>,.?~`|\\/-]/.test(password);
    const hasNumber = /\d/.test(password);
    const criteriaArray = [hasUpperCase, hasLowerCase, hasSpecialChar, hasNumber];
    const metCount = criteriaArray.filter(Boolean).length;
    return metCount >= 3 && password.length >= 8;
};